import React, { useState } from "react";
import fire from "../../../GlobalComponents/NftCard/assets/fire.png";
import icon1 from "../../../GlobalComponents/NftCard/assets/Icon-Acquire.png";
import icon2 from "../../../GlobalComponents/NftCard/assets/Icon-Drip.png";
import { NavHashLink } from "react-router-hash-link";
import heart from "../assets/heart.png";
import BidModal from "../../../GlobalComponents/BidModal/BidModal";
import ViewModal from "../../../GlobalComponents/ViewModal/ViewModal";
import useCountdown from "../../../hooks/useCountDown";
import { BuyOutNFT } from "../../../utils/functions";
import { toast } from "react-toastify";

//import { getEthersSigner } from "../../../ethers";
import { ethers } from "ethers";
const Card = (itemData) => {
  const [openBid, setOpenBid] = useState(false);
  var gold = "Gold";
  console.log(itemData);

  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();

  const Buyout = async () => {
    const res = await BuyOutNFT(itemData.tokenId, itemData.price, signer);
    if (res.success === true) {
      toast.success("Claim Successful");
    } else {
      toast.error("Transaction failed!");
    }
  };

  const [openView, setOpenView] = useState(false);
  const { days, hours, minutes, seconds } = useCountdown();
  return (
    <div>
      <div className="w-full md:w-[278px]  flex-none rounded-[20px] bg-main-black">
        <div className="flex justify-between items-center px-[20px] pt-[20px]">
          <h2 className="font-bold text-res-ls">
            NFT1 tokenId {Number(itemData.tokenId)} (
            {itemData.address == itemData.seller ? "Yours" : null})
          </h2>
          <div className="bg-[#09090A] flex justify-center w-[62px] h-[24px] rounded-[10px] items-center gap-[4px] text-[12px] leading-[20px]">
            <img src={heart} alt="" />
            <span>100</span>
          </div>
        </div>
        <div className="lg:max-h-[319px]  pt-[13px] px-[5px] lg:px-[20px] pb-[4px] relative">
          <img
            className="w-full md:w-[290px] min-h-[273px] mx-auto rounded-[20px]"
            src="https://ipfs.io/ipfs/Qmc4r44z6qRCAc2hsgPL92QrcUA8VtsEuYFNmnPHjF3WPG"
            alt=""
          />
          <div className="absolute w-[151px] left-1/2  bottom-[21px] -translate-x-1/2 bg-[#1F1F2C] rounded-[13px] h-[36px] flex justify-center">
            <div className="flex gap-[10px] items-center">
              <img className="w-[15px] h-[20px] " src={fire} alt="" />
              <p className="text-res-xxs font-bold leading-[24px]">
                {days} : {hours} : {minutes} : {seconds}
              </p>
            </div>
          </div>
        </div>
        <div className="px-[20px] flex justify-between pb-[15px]">
          <div>
            <h6 className="text-res-[13px] leading-[20px] text-[#8A8AA0] mb-[2px]">
              Tokens Vested
            </h6>
            <div className="flex  gap-[2px] ">
              <img className="w-[40px]" src={icon1} alt="" />
              <img className="w-[40px]" src={icon2} alt="" />
            </div>
            <div className=" ">
              <h1 className="text-[#8A8AA0] text-[13px] leading-[20px]  ">
                Buyout Price
                <span className="text-res-xxs font-bold text-white ml-[4px]">
                  {Number(itemData.price) / 10 ** 18} ETH
                </span>
              </h1>
            </div>
            <div className=" ">
              <h1 className="text-[#8A8AA0] text-[13px] leading-[20px]  ">
                Current Bid
                <span className="text-res-xxs font-bold text-white ml-[4px]">
                  4.89 ETH
                </span>
              </h1>
            </div>
          </div>
          <div className=" flex items-end ">
            <div className="flex flex-col items-end gap-[7px]">
              <div className="relative group">
                <button className=" w-[55px] h-[22px] border rounded-[20px] border-solid border-white font-semibold text-[10px] leading-[12px]">
                  View
                </button>
                <ViewModal
                  className={"right-0 -translate-x-[160%] z-[15] "}
                  open={openView}
                  contentWrapClassName={"!pr-[15px] !ml-0 !pl-0 !w-[260px]"}
                  wrapClassName="md:!min-w-[280px] !max-w-[280px]"
                  setOpen={setOpenView}
                ></ViewModal>
              </div>
              <button
                disabled={itemData.address == itemData.seller}
                //                style={{backgroundColor:itemData.address==itemData.seller?'red':'green'}}
                onClick={() => Buyout(true)}
                className=" w-[55px] h-[22px]  rounded-[20px] bg-custom-gradient font-semibold text-[10px] leading-[12px] text-light-black"
              >
                Buyout
              </button>
              <button
                onClick={() => setOpenBid(true)}
                className=" w-[55px] h-[22px]  rounded-[20px] bg-custom-gradient font-semibold text-[10px] leading-[12px] text-light-black"
              >
                Bid
              </button>
            </div>
          </div>
        </div>
      </div>

      {openBid && (
        <>
          <div className="modalOverlay"></div>
          <BidModal
            //  thum={thum}
            open={openBid}
            setOpen={setOpenBid}
            icon1={icon1}
            icon2={icon2}
          ></BidModal>
        </>
      )}
    </div>
  );
};

export default Card;
